package com.essntl.features.supplier.domain.repository

import com.essntl.features.supplier.domain.model.SupplierFilterOptions
import com.essntl.features.supplier.domain.model.SupplierModel

interface SupplierRepository {
    suspend fun get(id: String): Result<SupplierModel>

    suspend fun getCountSuppliersByCategory(categoryId: String): Result<Long>

    suspend fun getCountSuppliersByArea(areaId: String): Result<Long>

    suspend fun getAll(): Result<List<SupplierModel>>

    suspend fun getByIds(ids: List<String>): Result<List<SupplierModel>>

    suspend fun getSuppliersByContacts(contactIds: List<String>): Result<List<SupplierModel>>

    suspend fun getAll(
        page: Long,
        limit: Int = 10,
        filterOptions: SupplierFilterOptions,
    ): Result<List<SupplierModel>>

    suspend fun insert(model: SupplierModel): Result<SupplierModel>

    suspend fun update(model: SupplierModel): Result<SupplierModel>

    suspend fun delete(model: SupplierModel): Result<Unit>

    suspend fun getByPhoneNumbers(phoneNumbers: Set<String>): Result<List<SupplierModel>>

    suspend fun getByContactId(contactId: String): Result<SupplierModel?>
}
